export const baseStyle =
  'form-input border border-solid block w-full flex-1 text-sm disabled:cursor-not-allowed disabled:border-purple-200 disabled:text-purple-200 leading-5 placeholder:font-medium';
export const validStyle =
  'text-primary border-purple-300 placeholder:text-primary/50 focus:border-purple-500 focus:ring-purple-500';
export const invalidStyle =
  'text-danger border-danger placeholder:text-danger/50 focus:border-red-500 focus:ring-red-500';
